import * as Sentry from '@sentry/react';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE;
const release =
  import.meta.env.VITE_SENTRY_RELEASE ||
  import.meta.env.VITE_APP_VERSION ||
  import.meta.env.VITE_GIT_SHA;
const rawMonitoringFlag = import.meta.env.VITE_ENABLE_ERROR_MONITORING;
const enableMonitoring =
  typeof rawMonitoringFlag === 'string'
    ? rawMonitoringFlag.toLowerCase() === 'true'
    : (import.meta.env.PROD || import.meta.env.MODE === 'staging');

if (enableMonitoring) {
  if (sentryDsn) {
    Sentry.init({
      dsn: sentryDsn,
      environment,
      release,
      tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.2,
      integrations: [
        Sentry.replayIntegration({
          sessionSampleRate: import.meta.env.DEV ? 1.0 : 0.05,
          errorSampleRate: 1.0,
        }),
      ],
    });
    console.info('Sentry.js initialized with DSN', sentryDsn.replace(/https:\/\/.+@/, 'https://***@'));
    (globalThis as any).Sentry = Sentry;
  } else {
    console.warn('Sentry monitoring enabled but VITE_SENTRY_DSN is missing.');
  }
} else {
  if (import.meta.env.DEV) {
    console.info('Sentry monitoring disabled. Set VITE_ENABLE_ERROR_MONITORING=true to enable.');
  }
}

export { Sentry };
